<template>
	<div class="m-doc-content">
		<c-title>{{title}}</c-title>
		<div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'docContent',

		props: {
			title: {
				type: String,
				default: '单据详情'
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-doc-content {
		border-radius: .16rem;
		padding: .1rem .36rem .2rem;
		margin: 0 .2rem .2rem;
		background: #fff;

		&:nth-child(1) {
			margin-top: .2rem;
		}

		>>> .c-field {
			padding: .1rem 0;

			&-label {
				color: #999;
			}
		}
	}
</style>
